import { render } from "./CampaignTeaser.vue?vue&type=template&id=ee5d2dcc&scoped=true"
import script from "./CampaignTeaser.vue?vue&type=script&lang=js"
export * from "./CampaignTeaser.vue?vue&type=script&lang=js"

import "./CampaignTeaser.vue?vue&type=style&index=0&id=ee5d2dcc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5d2dcc"]])

export default __exports__